import "../../Projects/Maison_Sambin/Maison_Sambin.css";
import Hero from "../../Projects/Maison_Sambin/Hero.jsx";
import AboutUs from "../../Projects/Maison_Sambin/AboutUs.jsx";
import Banner from "../../Projects/Maison_Sambin/Banner.jsx";
import Card from "../../Projects/Maison_Sambin/Card.jsx";
import ImgFooter from "../../Projects/Maison_Sambin/ImgFooter.jsx";
import Footer from "../../general/Footer.jsx";

export default function MaisonSambin() {
  return (
    <div className="Maison_Sambin-page">
      <Hero />
      <AboutUs />
      <Banner
        img={require("../../../assets/img/projects/Maison_Sambin/Banner1.png")}
      />
      <Card />
      <Banner
        img={require("../../../assets/img/projects/Maison_Sambin/Banner2.png")}
      />
      <ImgFooter />
      <Footer />
    </div>
  );
}
